import { createAsyncThunk } from '@reduxjs/toolkit';
import OrganizationsResource from 'api/service/OrganizationsResource';

export const getSubscription = createAsyncThunk('organization/getSubscription', async (initialData) => {
  const organizationsResource = new OrganizationsResource();
  const orgId = initialData;
  const { status, data } = await organizationsResource.organization(orgId).subscription().get();
  if (status === 200) {
    return data;
  }
});

export const getCustomerPortal = createAsyncThunk('organization/getCustomerPortal', async (initialData) => {
  const organizationsResource = new OrganizationsResource();
  const orgId = initialData;
  const { status, data } = await organizationsResource.organization(orgId).subscription().customerPortal();
  if (status === 200) {
    return data;
  }
});

export const createSubscription = createAsyncThunk('organization/createSubscription', async (initialData) => {
  const organizationsResource = new OrganizationsResource();
  const orgId = initialData;
  const { status, data } = await organizationsResource.organization(orgId).subscription().create();
  if (status === 200) {
    return data;
  }
});
